import { ReactNode, createContext, useContext } from 'react';

type SubagentPanelContextValue = {
  openSubagentPanel: (childChatName: string) => void;
};

const SubagentPanelContext = createContext<SubagentPanelContextValue | null>(
  null,
);

export const SubagentPanelProvider = ({
  openSubagentPanel,
  children,
}: SubagentPanelContextValue & { children: ReactNode }) => (
  <SubagentPanelContext.Provider value={{ openSubagentPanel }}>
    {children}
  </SubagentPanelContext.Provider>
);

export const useSubagentPanel = () => useContext(SubagentPanelContext);
